import { render, staticRenderFns } from "./datePicker.vue?vue&type=template&id=56f89874&scoped=true"
import script from "./datePicker.vue?vue&type=script&lang=js"
export * from "./datePicker.vue?vue&type=script&lang=js"
import style0 from "./datePicker.vue?vue&type=style&index=0&id=56f89874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f89874",
  null
  
)

export default component.exports